import { render, staticRenderFns } from "./DisputeStatusTag.vue?vue&type=template&id=912e1a80&"
import script from "./DisputeStatusTag.vue?vue&type=script&lang=js&"
export * from "./DisputeStatusTag.vue?vue&type=script&lang=js&"
import style0 from "./DisputeStatusTag.vue?vue&type=style&index=0&id=912e1a80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports